import type { OverviewTournament } from '@/api/types';

export function tournamentLabel(tournament: OverviewTournament): string {
  return tournament.title || tournament.tournamentId;
}
